import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { TooltipHost, TooltipOverflowMode } from "@fluentui/react/lib/Tooltip";
import { uiSetActiveContactId } from "Store/Actions";
import { getAddress } from "Utils/Address";
import {
  Tile, TileBody, TileFooter, TileHeader
} from "Components/Generic/Tile";
import { LinkWithTooltip } from "Components/Generic/LinkWithTooltip";
import { ContactActions } from "./ContactActions";
import { ITileProps } from "../ITileProps";
import { ContactInfo } from "./ContactInfo";

export function ContactTile(props: ITileProps): JSX.Element {
  const { item } = props;
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(uiSetActiveContactId(item[`@id`]));
  }, [item, dispatch]);

  return (
    <Tile>
      <TileHeader>
        <LinkWithTooltip item={item} onClick={onClick} />
      </TileHeader>
      <TileHeader asSubHeader>
        <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={getAddress(item)}>
          {getAddress(item)}
        </TooltipHost>
      </TileHeader>
      <TileBody>
        <ContactInfo contact={item} />
      </TileBody>
      <TileFooter>
        <ContactActions contact={item} />
      </TileFooter>
    </Tile>
  );
}
